import { appSyncConfig } from "../../configs/reexports";

export type S3BucketKeyType = "LeakFinder" | "NodeFiles" | "UserFiles";

export const S3BucketKeys = {
  LEAK_FINDER: "LeakFinder",
  NODE_FILES: "NodeFiles",
  USER_FILES: "UserFiles",
};

export const S3Buckets = {
  LeakFinder: appSyncConfig.aws_leak_finder_s3_bucket,
  NodeFiles: appSyncConfig.aws_node_files_s3_bucket,
  UserFiles: appSyncConfig.aws_user_files_s3_bucket,
};
